import { BinIcon, LinkIcon, RightArrowIcon } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import Button from "../../../../components/Button";
import styles from "../CompaniesTable/CompaniesTable.module.scss";

export type CTACellModel = {
  key: "cta";
  value: {
    guid: string;
    numOfConnections: number;
    onRequestClick: () => void;
    onDeleteButtonClick: () => void;
    onRowClick: (
      event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
    ) => void;
    showDelete: boolean;
    buttonVariant: number | undefined;
    index: number;
    hideCell?: boolean;
  };
};

export function CtaCell({ value }: Pick<CTACellModel, "value">) {
  if (value.hideCell) return <></>;

  const buttonVariant =
    value.buttonVariant === value.index ? "primary" : "secondary";
  const buttonColor =
    value.buttonVariant === value.index ? "action" : "interface";
  return (
    <div className={classNames(styles.ctaContainer)}>
      <div className={styles.hover}>
        {!!value.numOfConnections && (
          <Button
            label="Link URL"
            size="small"
            variant="secondary"
            color="interface"
            className={styles.linkUrlButton}
            buttonName="Link URL"
            data-testid="companies-table-link-url"
            onClick={(event) => {
              value.onRequestClick();
              event.stopPropagation();
            }}
          >
            <LinkIcon />
          </Button>
        )}
        {value.showDelete && (
          <Button
            label="Delete company"
            className={styles.deleteButton}
            onClick={(
              event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
            ) => {
              value.onDeleteButtonClick();
              event.stopPropagation();
            }}
            data-testid="companies-table-delete"
            buttonName="Delete"
            eventProperties={{ companyId: value.guid }}
            color="negative"
            variant="secondary"
            size="small"
          >
            <BinIcon />
          </Button>
        )}
      </div>
      {!!value.numOfConnections && value.onRowClick && (
        <Button
          label="Company data"
          size="small"
          variant={buttonVariant}
          color={buttonColor}
          className={styles.underlyingDataButton}
          buttonName="Company data"
          data-testid="companies-table-underlying-data"
          onClick={(
            event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
          ) => {
            value.onRowClick(event);
            event.stopPropagation();
          }}
        >
          <RightArrowIcon />
        </Button>
      )}
      {!value.numOfConnections && (
        <Button
          size="small"
          className={styles.requestDataButton}
          label="Request data"
          key={value.guid}
          onClick={(event) => {
            value.onRequestClick();
            event.stopPropagation();
          }}
          data-testid="companies-table-request-data"
          buttonName="Request data"
          eventProperties={{ companyId: value.guid }}
          variant={buttonVariant}
        />
      )}
    </div>
  );
}
